// extracted by mini-css-extract-plugin
export default {"space":"sign-request_space__Bx9Sn"};